import type React from "react";
import {
  DialogTitle,
  Avatar,
  Typography,
  IconButton,
  Box,
  Divider,
} from "@mui/material";
import { Close as CloseIcon, SmartToy as BotIcon } from "@mui/icons-material";

interface ChatHeaderProps {
  botName: string;
  onClose: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ botName, onClose }) => {
  return (
    <>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar sx={{ bgcolor: "primary.main" }}>
            <BotIcon />
          </Avatar>
          <Typography variant="h6">{botName}</Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
    </>
  );
};
